"use strict";
var r, t;
function a() {
  if (t) return r;
  t = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return r = e, r;
}
export {
  a as __require
};
//# sourceMappingURL=index.es318.js.map
